import React, { useState, useEffect } from "react";
import { Button, Row, Card, Form, Spin, Col, Typography } from "antd";
import {
  ArrowLeftOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import styles from "./styles/loginpage.module.css";
import { SIZES, COLORS } from "../../../constants";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Notification from "../../../components/shared/Notification";
import LoginLogo from "./LoginLogo";
import FormFields from "./FormFields";
import { login } from "../../http-request/user";
import BackgroundContainer from "../../components/BackgroundContainer/BackgroundContainer";
import { useDispatch } from "react-redux";
import { setUser } from "../../../reducers/user.reducer";


const { Title } = Typography;
const antIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
);

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forms] = Form.useForm();
  const location = useLocation();
  const { usertype } = location?.state;
  const [isLoading, setisLoading] = useState(false);

  useEffect(() => {
    if (!usertype) {
      Notification("Error", "Please select a User Type to Login!", "error");
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usertype]);

  return (
    <div className={styles.container}>
      <BackgroundContainer>
        <div className={styles.cardContainer}>
          <LoginLogo />

          <Card style={{ borderRadius: SIZES.base, width: 320, height: 350 }}>
            <Row justify="space-between">
              <Col style={{ fontSize: "15px" }}>
                <Link to="/" className={styles.initialColor}>
                  <ArrowLeftOutlined />
                </Link>
              </Col>
              <Col style={{ fontSize: "15px" }}>
                <Link to="/" className={styles.initialColor}>
                  <CloseOutlined />
                </Link>
              </Col>
            </Row>
            <center>
              <Title className={styles.margins} level={3}>
                Login as {usertype}
              </Title>
            </center>
            <Form
              form={forms}
              className={styles.margins}
              onFinish={async (values) => {
                let _token = "";
                setisLoading(true);
                await login({ ...values, usertype })
                  .then((data) => {                    
                    dispatch(setUser(data.user))
                    _token = data?.token;
                  })
                  .finally(() => {
                    setisLoading(false);
                    forms.setFieldsValue({ password: "" });
                    if (_token) {
                      localStorage.setItem("token", _token);
                      navigate(`/v2/${usertype}`);
                    }
                  });
              }}
            >
              <FormFields />
              <Button
                disabled={isLoading}
                block
                type="primary"
                htmlType="submit"
              >
                {isLoading ? <Spin indicator={antIcon} /> : "Login"}
              </Button>
            </Form>
            <center>
              <Link to={"forgot-password"}>Forgot Password?</Link>
            </center>
          </Card>
        </div>
      </BackgroundContainer>
    </div>
  );
}

export default LoginPage;
